import { Box, Text, Flex, Icon, keyframes } from '@chakra-ui/react';
import { FiAlertTriangle, FiCheck } from 'react-icons/fi';
import React from 'react';
import { ff } from '../../../theme';

const slideIn = keyframes`
  from { transform: translateY(100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

interface CustomToastProps {
  title: string;
  description: string;
  status: 'success' | 'error';
}

export const CustomToast: React.FC<CustomToastProps> = ({ title, description, status }) => {
  const isSuccess = status === 'success';

  return (
    <Box
      animation={`${slideIn} 0.4s ease-out`}
      bg={ff.ink}
      borderRadius="16px"
      px={4}
      py="14px"
      maxW="sm"
      w="100%"
    >
      <Flex align="center" gap={3}>
        <Flex
          w="32px"
          h="32px"
          borderRadius="full"
          bg={isSuccess ? ff.lime : ff.danger}
          align="center"
          justify="center"
          flexShrink={0}
        >
          <Icon as={isSuccess ? FiCheck : FiAlertTriangle} boxSize="16px" color={isSuccess ? ff.ink : 'white'} />
        </Flex>
        <Box flex="1" minW={0}>
          <Text fontWeight="600" fontSize="14px" color="white">
            {title}
          </Text>
          <Text fontSize="13px" color="whiteAlpha.800" mt={0.5}>
            {description}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export const createCustomToast = (toast: any) => {
  return {
    showSuccessToast: (title: string, description: string) => {
      toast({
        position: 'bottom',
        duration: 3000,
        isClosable: true,
        render: () => (
          <CustomToast
            title={title}
            description={description}
            status="success"
          />
        ),
      });
    },
    showErrorToast: (title: string, description: string) => {
      toast({
        position: 'bottom',
        duration: 4000,
        isClosable: true,
        render: () => (
          <CustomToast
            title={title}
            description={description}
            status="error"
          />
        ),
      });
    },
  };
}; 